var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kalan-dialog',{attrs:{"title":"Candados","height":"650px"}},[_c('v-card',{staticClass:"mx-auto elevation-0",attrs:{"height":"100%"}},[_c('kalan-list',{attrs:{"loading":_vm.loading,"getTitle":_vm.getTitle,"getSubTitle":_vm.getSubTitle,"items":_vm.items,"search":_vm.search,"actions":_vm.listActions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }